import _ from 'lodash';
import { schemaShouldShowConfigTypes, schemaTypes } from './config';
import { currencyLabel } from 'v2/common/constants';

const schemaToLabelMap = {
  stopLoss: {
    isDisplay: true,
    displayName: 'Current Transaction Loss %',
    shouldShowConfigs: [
      schemaShouldShowConfigTypes.adjustmentLeftOperand,
      schemaShouldShowConfigTypes.adjustmentRightOperand
    ],
  },
  stopGain: {
    isDisplay: true,
    displayName: 'Current Transaction Profit %',
    shouldShowConfigs: [
      schemaShouldShowConfigTypes.adjustmentLeftOperand,
      schemaShouldShowConfigTypes.adjustmentRightOperand
    ],
  },
  stopLossAmount: {
    isDisplay: true,
    displayName: `Current Transaction Loss ${currencyLabel}`,
    shouldShowConfigs: [
      schemaShouldShowConfigTypes.adjustmentLeftOperand,
      schemaShouldShowConfigTypes.adjustmentRightOperand
    ],
  },
  stopGainAmount: {
    isDisplay: true,
    displayName: `Current Transaction Profit ${currencyLabel}`,
    shouldShowConfigs: [
      schemaShouldShowConfigTypes.adjustmentLeftOperand,
      schemaShouldShowConfigTypes.adjustmentRightOperand
    ],
  },
  transactionLossPercent: {
    isDisplay: window?.isAdmin,
    displayName: 'Transaction Loss %',
    shouldShowConfigs: [
      schemaShouldShowConfigTypes.entryLeftOperand,
      schemaShouldShowConfigTypes.exitLeftOperand,
      schemaShouldShowConfigTypes.adjustmentLeftOperand,
    ],
  },
  transactionGainPercent: {
    isDisplay: window?.isAdmin,
    displayName: 'Transaction Profit %',
    shouldShowConfigs: [
      schemaShouldShowConfigTypes.entryLeftOperand,
      schemaShouldShowConfigTypes.exitLeftOperand,
      schemaShouldShowConfigTypes.adjustmentLeftOperand,
    ],
  },
  transactionLossAmount: {
    isDisplay: window?.isAdmin,
    displayName: 'Transaction Loss Amount',
    shouldShowConfigs: [
      schemaShouldShowConfigTypes.entryLeftOperand,
      schemaShouldShowConfigTypes.exitLeftOperand,
      schemaShouldShowConfigTypes.adjustmentLeftOperand,
    ],
  },
  transactionGainAmount: {
    isDisplay: window?.isAdmin,
    displayName: 'Transaction Profit Amount',
    shouldShowConfigs: [
      schemaShouldShowConfigTypes.entryLeftOperand,
      schemaShouldShowConfigTypes.exitLeftOperand,
      schemaShouldShowConfigTypes.adjustmentLeftOperand,
    ],
  }
};

export const buildStrategyStopOutputSchema = () => {
  return _.chain(schemaToLabelMap)
    // will enable this in future for the overAll case calculation
    // .pickBy(({ isDisplay }) => isDisplay)
    .pickBy(() => false)
    .map((config, name) => {
      return {
        type: schemaTypes.number,
        category: 'strategyStop',
        name,
        label: config?.displayName,
        shouldShowConfigs: config?.shouldShowConfigs,
        priority: 200,
        schemaName: name
      };
    })
    .value();
};
